import {lazy} from 'react';

import type {RouteConfig} from '../types';

import {Loadable} from '../components/Loadable';
import {publicRoutesPath} from './path';

const AccessDeniedPage = Loadable(
  lazy(() =>
    import(
      '@src/v2/pages/AccessDenied' /* webpackChunkName: "access-denied-page" */
    ).then(module => ({default: module.AccessDeniedPage})),
  ),
);
const WidgetPage = Loadable(
  lazy(() =>
    import('@src/v2/pages/Widget' /* webpackChunkName: "widget-page" */).then(
      module => ({default: module.WidgetPage}),
    ),
  ),
);
const WidgetBookingPage = Loadable(
  lazy(() =>
    import(
      '@src/v2/pages/WidgetBooking' /* webpackChunkName: "widget-booking-page" */
    ).then(module => ({default: module.WidgetBookingPage})),
  ),
);
const UnknownPage = Loadable(
  lazy(
    () => import('@src/pages/Unknown' /* webpackChunkName: "unknown-page" */),
  ),
);
const LoginPage = Loadable(
  lazy(() => import('@src/pages/Login' /* webpackChunkName: "login-page" */)),
);
const MailchimpUnsubscribePage = Loadable(
  lazy(
    () =>
      import(
        '@src/pages/MailchimpUnsubscribe' /* webpackChunkName: "mailchimp-unsubscribe-page" */
      ),
  ),
);

export const publicRoutes = [
  {
    element: <LoginPage />,
    isPublic: true,
    path: publicRoutesPath.login.$path(),
  },
  {
    element: <MailchimpUnsubscribePage />,
    isPublic: true,
    path: publicRoutesPath.emailUnsubscribe.$path(),
  },
  {
    element: <AccessDeniedPage />,
    isPublic: true,
    path: publicRoutesPath.accessDenied.$path(),
  },
  {
    element: <WidgetPage />,
    isPublic: true,
    path: publicRoutesPath.widget.$path(),
  },
  {
    element: <WidgetBookingPage />,
    isPublic: true,
    path: publicRoutesPath.widgetBooking.$path(),
  },
  {
    element: <UnknownPage />,
    isPublic: true,
    path: '*',
  },
] satisfies RouteConfig[];
